import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import { ERR_CHECKBOX_NOT_CEHCKED } from "../../../ErrorMessages";
import InlineError from "../../messages/InlineError";

class CheckboxControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: !(
        this.props.defaultData === "" ||
        this.props.defaultData === undefined ||
        this.props.defaultData === false
      ),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(nextProps.control.FieldId);
      if (element) element.focus();
    }
    this.setState({
      value: !(
        nextProps.defaultData === "" ||
        nextProps.defaultData === undefined ||
        nextProps.defaultData === false
      ),
    });
  }

  onChange = (e) => {
    this.props.notifyChangeToForm(e, {
      name: e.target.name,
      value: e.target.checked,
    });
  };

  render() {
    const { control } = this.props;
    const color = control.isMandatory ? "red" : "black";
    return (
      <Form.Field error={!!control.error}>
        <div className={"padding-top-11"}>
          <label
            htmlFor={control.FieldName}
            style={{ textAlign: "center", color }}
          >
            <input
              id={control.FieldId}
              name={control.FieldName}
              checked={this.state.value}
              onChange={this.onChange}
              type="checkbox"
              className={`ui checkbox margin-top-2`}
            />{" "}
            {control.FieldLabel}
          </label>
        </div>
        {/* {<br />} */}
        {control.error !== undefined && control.error !== "" && (
          <InlineError text={ERR_CHECKBOX_NOT_CEHCKED} />
        )}
      </Form.Field>
    );
  }
}

export default CheckboxControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/CheckboxControl.js